// TabContent1.js
import React, { useState } from 'react';
import ProgressionTab from '../../../../theme/ProgressionBuilder/ProgressionTab';
import SelectGroup from '../../../../theme/Select/SelectGroup';
import { ReactComponent as MoneybirdLogo } from '../../../../../styles/svg/moneybird.svg';
import { ReactComponent as AfasLogo } from '../../../../../styles/svg/afas.svg';
import { ReactComponent as WefactLogo } from '../../../../../styles/svg/wefact.svg';
import { ReactComponent as StockHubLog } from '../../../../../styles/svg/stockhub-logo-black.svg';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import { useTranslation } from 'react-i18next';

/**
 * TabContent1 Component
 * 
 * Props:
 * - handleDataUpdate: Function, updates the data in the Redux state.
 * - handleNext: Function, navigates to the next tab.
 */
const Content = (props) => {
    
        const columns = [
            {title: "Moneybird", logo: <MoneybirdLogo width={60} height={60}/>, key: "moneybird"},
            {title: "AFAS", logo: <AfasLogo width={60} height={60}/>, key: "afas"},
            {title: "Wefact", logo: <WefactLogo width={60} height={60}/>, key: "wefact"},
            {title: "Stockhub PDF", logo: <StockHubLog width={60} height={60}/>, key: "stockhub_pdf"},
            {title: "Exact Online", logo: <AccountBalanceIcon sx={{ fontSize: 60 }}/>, key: "exact_online"},
        ]

        const handleOptionSelect = (option) => {
            const credentialsObj = getCredentialsFromType(columns[option].key);
            props.handleDataUpdate({ credentials: credentialsObj });
            props.handleDataUpdate({ selectedOption: option, type: columns[option].key });
            props.handleNext("tabDetails");
        };

        const getCredentialsFromType = (type) => {
            switch(type) {
                case "moneybird": 
                    return {administration_id: "", access_token: ""}; 
                case "afas": 
                    return {token: "", api_key: "", environment_number: ""}; 
                case "wefact":
                    return {api_key: ""};
                case "exact_online":
                    return {region: "nl", client_id: "", client_secret: ""};
                case "stockhub_pdf":
                    return {name: "", addressLine: "", postal: "", city: "", phone: "", website: "", email: "", iban:"", btw: "", kvk: "", reminderTerm: 0, reminderPaymentTerm: 0, bcc: ""};//, foottext: ""};
                default:
                    return {};
            }
        }
    
        return (
            <div>
                <SelectGroup selected={-1} setSelected={handleOptionSelect} options={columns} image={true} />
            </div>
        );
    };

const ChooseType = (props) => {

    return (
        <ProgressionTab 
            tabId="tabChooseType" 
            step={1}
            maxSteps={2}
        >
            <Content/>
        </ProgressionTab>
    )
}

export default ChooseType;